
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/download-centre",
      function () {
        return require("private-next-pages/support/download-centre/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/download-centre"])
      });
    }
  